import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SharedInfoService } from './partsCatalog/sharedInfo.service';
import { NotificationService } from './shared/header/notification.service';

@Injectable()
export class AuthGuard  {

  constructor(private readonly router: Router,
    private readonly sharedInfoService:SharedInfoService,
    private readonly notificationService: NotificationService) {}

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.isKitListBypass(state)) {
      return true;
    }
    this.dispatchViewNotification(route, state);
    return this.resolveNavigation(state);
  }

  private isKitListBypass(state: RouterStateSnapshot): boolean {
    return !!this.sharedInfoService.inputEsn && (state.url.startsWith('/esn-entry/main/kit-list')
      || state.url.startsWith('/esn-entry/main/search/inner/kit-list')
      || state.url.startsWith('/esn-entry/main/kit-set-view/kit-set-details/'));
  }

  private dispatchViewNotification(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
    if (route.params['source'] === 'parts-search') {
      this.setPartsCatalogView(route.params.partNo, 'parts-search');
    } else if (route.params['source'] === 'parts-search-global') {
      this.setPartsCatalogView(route.params.partNo, 'parts-search-global');
    } else if (/.*part-details.*/.test(state.url)) {
      this.setPartsCatalogView(route.params.partNo, 'partViewUpdate');
    } else if ((state.url.startsWith('/esn-entry/main/kits') || state.url.startsWith('/esn-entry/main/sets') || state.url.startsWith('/esn-entry/main/kit-list')) && this.sharedInfoService.currentOption) {
      const esn = this.sharedInfoService.currentEsnInfo && this.sharedInfoService.inputEsn;
      this.setPartsCatalogView(esn || ' ', 'kit/gasketViewUpdate');
    } else if (route.params['source'] !== 'option') {
      const esn = this.sharedInfoService.currentEsnInfo && this.sharedInfoService.inputEsn;
      this.setPartsCatalogView(esn || ' ', 'esnViewUpdate');
    }
  }

  private resolveNavigation(state: RouterStateSnapshot): boolean {
    if (this.isEsnAccessibleUrl(state)) {
      if (this.requiresMissingOption(state)) {
        this.router.navigate(['/esn-entry/main']);
        return false;
      }
      return true;
    }
    this.router.navigate(['/esn-entry/main']);
    return false;
  }

  private isEsnAccessibleUrl(state: RouterStateSnapshot): boolean {
    return !!this.sharedInfoService.currentEsnInfo.esn
      || state.url === '/esn-entry/main/find-esn'
      || state.url === '/esn-entry/main/esn-error'
      || state.url === '/esn-entry/npbumain/esn-error'
      || state.url.startsWith('/esn-entry/main/kits')
      || state.url.startsWith('/esn-entry/main/gasket-set')
      || state.url.startsWith('/esn-entry/main/part-details/')
      || state.url.startsWith('/esn-entry/main/option-details/')
      || ((state.url.startsWith('/esn-entry/main/search') || state.url.startsWith('/esn-entry/npbumain/search')) && !state.url.startsWith('/esn-entry/main/search/inner'));
  }

  private requiresMissingOption(state: RouterStateSnapshot): boolean {
    return (state.url.startsWith('/esn-entry/main/kits')
      || state.url.startsWith('/esn-entry/main/gasket-set')
      || state.url.startsWith('/esn-entry/main/option-details/')) && !this.sharedInfoService.currentOption;
  }

  private setPartsCatalogView(data: any, viewString: string) {
    setTimeout(() => {
        this.notificationService.setGlobalvalue(data);
        this.notificationService.setType = viewString;
        this.notificationService.notificationEBUUpdated(data);
    }, 0);
  }
}
